import { CircularProgress, Grid, Typography } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import SchoolIcon from '@material-ui/icons/School';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

function PrinterKey(props) {
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState('');

  const errorMessage = 'Bir hata oluştu!..';

  useEffect(() => {
    let job = loadBaslandiJob()[0];
    if (job.PRINTER_KEY) {
      setKey(job.PRINTER_KEY);
    }
  }, []);

  const getPrinterKey = (type, typeText) => {
    confirmAlert({
      message: typeText + ' müşteri için 3D Printer aktivasyon kodu alınacaktır. Devam etmek istiyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => getPrinterKeyYes(type)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  const getPrinterKeyYes = (type) => {
    setLoading(true);
    let job = loadBaslandiJob()[0];
    axios.get(`GetPrinterKey/${job.FisNo}/${type}`)
      .then(response => {
        if (parseInt(response.data.ErrorCode) === 0) {
          job = loadBaslandiJob()[0];
          job = {
            ...job,
            PRINTER_KEY: response.data.ErrorDescription
          }
          saveBaslandiJob(job);
          setKey(response.data.ErrorDescription);
        } else {
          setKey(errorMessage);
        }
        setLoading(false);
      }).catch(error => {
        setKey(errorMessage);
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  }

  return (
    loading ?
      <CircularProgress
        status={'loading'}
        style={{ marginLeft: '50%' }}
      />
      :
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body1" className={props.className} style={{ width: '100%', verticalAlign: 'center' }}>
              3D Printer Aktivasyon Kodu: <b>{key.length === 0 ? 'Kod üretin' : key}</b>
            </Typography>
          </Grid>
        </Grid>
        {(key.length === 0 || key === errorMessage) &&
          <Grid container>
            <Grid item xs={1}>
              <SchoolIcon color="primary" onClick={() => getPrinterKey(1, 'Kurumsal')} />
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1">
                <b>Kurumsal okul için kod üret</b>
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={1}>
              <PersonIcon color="primary" onClick={() => getPrinterKey(2, 'Bireysel')} />
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1">
                <b>Normal kullanıcı için kod üret</b>
              </Typography>
            </Grid>
          </Grid>
        }
      </div>

  );
}

export default PrinterKey;
